<script type="text/babel">
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import RestoreScrollOnPageBack from 'dashboard-js/mixins/RestoreScrollOnPageBack'

export default {
    mixins: [RestoreScrollOnPageBack],
    props: ['user'],

    data() {
        return {
            addressForm: new SparkForm(this.user),
            stripeForm: new SparkForm(),
        }
    },

    methods: {
        connectStripe(event) {
            if (this.user.billing_address === null) {
                swal({
                    title: 'Udfyld faktureringsaddresse',
                    text:
                        'Før du kan forbinde din stripe konto, bedes du udfylde din faktureringsaddresse.',
                    type: 'warning',
                    allowEscapeKey: true,
                    allowClickOutside: true,
                    showConfirmButton: true,
                    customClass: 'success',
                    confirmButtonText: 'Forstået',
                })

                return this.addressForm.setErrors({
                    billing_address: '',
                    billing_city: '',
                    billing_zip: '',
                    billing_country: '',
                })
            }

            Spark.post(event.target.action, this.stripeForm).then(response => {
                NavigationProvider.go(response.redirect)
            })
        },

        updateAddress() {
            Spark.put(route('api.profile.address.update'), this.addressForm).then(response => {
                Bus.$emit('userUpdated', response.data)
                Object.assign(this.addressForm, response.data)
            })
        },
    },
}
</script>
